export default __webpack_public_path__ + "static/media/12.ea88b0ab.jpg";